module.exports = __webpack_public_path__ + "img/gb901.prt.71bbe08a.jpg";